// This should include code that runs before the concierge is determined to be enabled.
// This is directly depended on by index.ts so should be very minimal and not import lots of other concierge files.

export const CONCIERGE_PRODUCT_FORM_CONTAINER_ID =
  "redo-concierge-product-form-target";
